<script>
	import { GLOSSARY } from '$lib/routes'
	import { t } from '$lib/translations'
	export let data = null
</script>

<div class="relative px-4">
	<section class="page-wrapper">
		<nav
			class="breadcrumbs"
			aria-label="Breadcrumb"
			itemscope
			itemtype="https://schema.org/BreadcrumbList"
		>
			<ol class="my-4">
				<li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
					<a href="/{GLOSSARY}" itemprop="item">
						<span itemprop="name">&larr; {t('web.routes.GLOSSARY')}</span>
					</a>
					<meta itemprop="position" content="1" />
				</li>
			</ol>
		</nav>
		<div class="mx-auto w-full max-w-2xl">
			<article class="glossary">
				<h1>{data.title}</h1>
				{@html data.content}
			</article>
		</div>
	</section>
</div>

<style lang="scss">
	.breadcrumbs a {
		color: theme('colors.primary-500');
		font-size: theme('fontSize.base');
		font-weight: theme('fontWeight.normal');
	}
	.glossary :global(p),
	.glossary :global(li) {
		font-weight: 300;
		line-height: 1.5;
		margin-bottom: 1.75rem;
		font-size: 1.25rem;
		color: #000;
	}

	.glossary :global(li) {
		list-style: disc;
		list-style-position: outside;
		margin-left: 1em;
	}

	.glossary :global(a) {
		@apply text-primary-500;
	}
</style>
